import appProperty from './app-property.store'
import forgotPassword from './forgot-password.store'
import menuResource from './menu-resource.store'
import menuSide from './menu-side.store'
import menu from './menu.store'
import resource from './resource.store'
import roleMenu from './role-menu.store'
import roleResource from './role-resource.store'
import role from './role.store'
import userRole from './user-role.store'
import user from './user.store'
import securityEvent from './security-event.store'
import userInstead from './user-instead.store'
import otp from './otp.store'
import emailToken from './email-token.store'
import userReport from './user-report.store'

export default {
    appProperty,
    forgotPassword,
    menuResource,
    menuSide,
    menu,
    resource,
    roleMenu,
    roleResource,
    role,
    userRole,
    user,
    securityEvent,
    userInstead,
    otp,
    emailToken,
    userReport
}